<script>
    import "bootstrap/dist/js/bootstrap.js";
    import "@/assets/scss/app.scss";
    // import FeedbackForm from "@/modules/overlays/FeedbackForm.vue";
    import 'bootstrap-vue/dist/bootstrap-vue.css';
    import '@progress/kendo-theme-bootstrap/dist/all.css';

    export default {
        name: "App",
        data() {
            return {
                timer: null,
                timer1: null,
            };
        },
        mounted() {
            this.updateTheme();
        },
        methods: {
            moveEvent() {
                let path = ["/"];
                if (!path.includes(this.$route.path)) {
                    clearTimeout(this.timer);
                    this.init();
                    clearTimeout(this.timer1);
                    this.extendSession();
                }
            },
            init() {
                this.timer = setTimeout(() => {
                    this.$api.user.logout();
                    this.$store.commit("clearStoredData");
                    alert(
                        "You have been logged out due to inactivity. You will now be redirected to the login page."
                    );
                    this.$window.location.href = "/portal";
                }, 20 * 60 * 1000);
            },
            extendSession() {
                this.timer1 = setTimeout(() => {
                    this.$api.user.extendSession();
                }, 19 * 60 * 1000);
            },
            updateTheme() {
                document.documentElement.setAttribute("theme", this.currentTheme);
            },
        },
        computed: {
            currentTheme() {
                let match = this.$route.matched.find((record) => {
                    if (record.meta.theme) return true;
                });
                return match?.meta?.theme ?? "patient";
            },
        },
        watch: {
            "$route.path": {
                handler() {
                    this.updateTheme();
                },
                immediate: true,
            },
        },
    };
</script>
<template>
    <div id="app" @mousemove="moveEvent" @click="moveEvent" data-role="page">
        <router-view class="vh_div"></router-view>
        <!-- <FeedbackForm></FeedbackForm> -->
    </div>
</template>
